import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '../../richText';

interface CaseStudyQuoteProps {
  content: Document;
  name: string;
  positionCompany: string;
}

export const CaseStudyQuote: React.FC<CaseStudyQuoteProps> = ({
  content,
  name,
  positionCompany,
}) => {

  return (
    <div className="cs-block-stone bg-stone">
      <div className="relative w-3/4 px-4 py-32 mx-auto text-white md:px-24 md:max-w-3xl">
        <div className="mb-10">
          <RichText content={content} />
        </div>
        <p><strong>{name}</strong> {positionCompany && positionCompany}</p>
      </div>
    </div>
  );
};
